import { Injectable } from '@angular/core';
import { ShTaskFacetDataService } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class DigihavenTaskFacetDataService extends ShTaskFacetDataService {
    protected FACETS_ENDPOINT = 'v2/tasks/facets';
}
